const THRESHOLD = 0.98

export const isUsageNearLimit = (used: number, total: number) => {
  if (total > 0) {
    return used / total >= THRESHOLD
  }

  return false
}
